import { TrackingPage } from "@outschool/ui-legacy-component-library";
import { DeviceType, DeviceTypeContext } from "@outschool/ui-utils";
import ldTruncate from "lodash/truncate";
import React from "react";
import Helmet from "react-helmet";

import SimpleLayout, { SimpleLayoutProps } from "../layouts/SimpleLayout";

export type MetaTags = {
  description?: string;
  canonicalUrl?: string;
  image: string;
};

export default function ContentfulPageLayout({
  children,
  title,
  metaTags,
  deviceType,
  trackingName,
  simpleLayoutProps
}: React.PropsWithChildren<{
  title: string;
  metaTags?: MetaTags;
  deviceType: DeviceType;
  trackingName: string;
  simpleLayoutProps?: Partial<SimpleLayoutProps>;
}>) {
  const device = { deviceType };

  return (
    <DeviceTypeContext.Provider value={device}>
      <TrackingPage
        impressionEventName={trackingName}
        uniqueId={trackingName}
        name={trackingName}
        useLinkTracking
      >
        {setImpressionNode => (
          <SimpleLayout
            ref={node => {
              if (node) {
                setImpressionNode(node as HTMLElement);
              }
            }}
            allowCategoriesNavbar
            sx={{ overflow: "hidden" }}
            {...simpleLayoutProps}
          >
            {/* Webpage title */}
            <Helmet>
              {/* eslint-disable-next-line i18next/no-literal-string */}
              <title>{`${title} | Outschool`}</title>
              {metaTags?.image && (
                <meta property="og:image" content={metaTags.image} />
              )}
              {metaTags?.description && (
                <meta
                  name="description"
                  content={ldTruncate(metaTags.description, {
                    length: 155,
                    separator: " "
                  })}
                />
              )}
              {metaTags?.description && (
                <meta
                  property="og:description"
                  content={metaTags.description}
                />
              )}
              {metaTags?.canonicalUrl && (
                <meta property="og:url" content={metaTags.canonicalUrl} />
              )}
              {metaTags?.canonicalUrl && (
                <link rel="canonical" href={metaTags.canonicalUrl} />
              )}
            </Helmet>

            {/* Content */}
            {children}
          </SimpleLayout>
        )}
      </TrackingPage>
    </DeviceTypeContext.Provider>
  );
}
